import React, {useContext, useState} from 'react';
import ReactDOM from 'react-dom';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonButtons, IonButton, IonMenuButton, IonModal, IonLabel, IonGrid, IonRow, IonCol, IonFooter } from '@ionic/react';


import '../../../css/layout.css';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export function ProfileSetting_PaymentInfo (props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);



    return (
        <React.Fragment>            
        {props.openModal == true ?
        (

            <IonModal isOpen={ props.openModal }>

                    <IonHeader style={{color: 'black'}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <h3>EMPLOYEE PAY INFO</h3>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>

                    <IonContent className='grid_content'>
                        <IonItem>
                            <IonLabel>Company Name: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonLabel>Bank Account First Name: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonLabel>Bank Account Last Name: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonLabel>Company Phone Number: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonLabel>Bank Name: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonLabel>Bank Account Number: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonLabel>Bank Routing Number: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>
                        <IonItem>
                            <IonLabel>Bank Branch Location: </IonLabel>
                            <IonButton> Update </IonButton>
                        </IonItem>

                    </IonContent>
                    <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonButton onClick={() => props.closeModal()}> Close </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonFooter>
            </IonModal>
                    
            ) : null }
            </React.Fragment>

    );
};


